<template>
  <div id="Char-Type-Abs" >
      <div class="content-char-type" >
        <b-row align-v="center">
            <!-- Estadisticas -->
            <b-col cols="12" md="4" lg="6">
              <div class="chart-type">
                <PieChart :chartData="chartData" :chart-options="chartOptions" />
              </div>
            </b-col>
            <!-- end -->
            <!-- Tabla  -->
            <b-col cols="12" md="8" lg="6">
              <div v-for="(data, indexData) in totalAbsenteeism"
                   :key="indexData">
                <div class="d-flex w-100 align-items-center my-2" >
                  <div class="number-percentage">
                    <h3 class="font-weight-bold m-0 mr-3">
                      {{ Number.parseFloat(data.percentage).toFixed(2) }} %
                    </h3>
                  </div>
                  <div class="con-bullets">
                    <div
                        class="bullets m-0 mr-3"
                        :style="`background-color:${stadisticsColors[indexData]}`">
                    </div>
                  </div>
                  <div class="title-grap">
                    <p
                        class="m-0 user-select-none pointer"
                        @click.prevent="clickedAbsenteeism(data), clickedDiagnosticGroup(data)">
                      {{ data.name }}
                    </p>
                  </div>

                </div>
              </div>
            </b-col>
            <!-- end -->
        </b-row>
      </div>
  </div>
</template>

<script>
import PieChart from '@/components/charts/PieChartDetail.js'
export default {
  props: {
    totalAbsenteeism: [],
    time:{}
    ,loading: Boolean
  },
  components: {
    PieChart
  }
  ,data() {
    return {
      stadisticsColors:[
        "#000186",
        "#C9CAFF",
        "#4E50F3",
        "#5D5FEF",
        "#53BE6B",
        "#8D00A5",
        "#B039CE",
        "#3713C7",
        "#0075FF",
        "#004BD1",
        "#59A5FF",
        "#1719DA"
      ]
    }
  }
  ,computed: {
    chartData ()
    {
      let data = {
        labels:[],
        datasets: [
          {
            backgroundColor:[],
            data: []
          }
        ]
      }
      this.totalAbsenteeism.forEach((element, index) => {
        data.labels.push(element.name)
        data.datasets[0].backgroundColor.push(this.stadisticsColors[index])
        data.datasets[0].data.push(element.percentage)
      })
      return data
    }
    ,chartOptions ()
    {
      return {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  }
  ,methods: {
    clickedDiagnosticGroup ({ id })
    {
      this.$emit('clicked:diagnosticGroup', id)
    }
    ,clickedAbsenteeism ({ id })
    {
      this.$emit('clicked:absenteeism', id)
    }
  }
}
</script>

<style lang="scss">
#absenteeismIndex{
  .chart-type{
    width: 70%;
    margin: 0 auto;
    padding: 5px;
  }
  @media (min-width: 768px) {
    .chart-type{
      width: 70%;
      margin: 0 auto;
      padding: 30px;
    }
  }
  .chartjs-render-monitor {
    width: 100% !important;
    height: 100% !important;
  }
  .number-percentage{
    width: 9rem;
    white-space: nowrap;
  }
  .con-bullets{
    width: 4rem;
  }
  .title-grap{
    min-width: 37rem;
    width: 100%;
  }
  .bullets{
    height:15px;
    width:15px;
    border-radius: 50px;
  }
  .tabs{
    margin-top: 1rem;
    margin-bottom: 1rem;
    .nav-tabs{
      border: 1px solid #C9CAFF !important;
      border-radius: 48px;
      padding: 3px;
      display: inline-flex;
    }
    .nav-link{
      line-height: 1.2;
    }
    .nav-link.active{
      background: #5D5FEF;
      border-radius: 20px;
      color: #FFFFFF !important;
    }
    .nav-link:hover{
      border: none;
    }
  }
}
</style>